import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

// material-ui
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { Theme } from '@mui/material/styles';
// import Toolbar from '@mui/material/Toolbar';
import useMediaQuery from '@mui/material/useMediaQuery';

// project imports
import Loader from 'components/Loader';
import { RestaurantProvider } from 'contexts/RestaurantContext';
import useConfig from 'hooks/useConfig';
import { USER_ROLES } from 'utils/role-utils';
import RoleGuard from 'utils/route-guard/RoleGuard';
import Drawer from './Drawer';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

// ==============================|| MAIN LAYOUT ||============================== //

export default function RestaurantLayout({ onlySpanish = false }: { onlySpanish?: boolean }) {
  const { i18n, onChangeLocalization } = useConfig();

  useEffect(() => {
    if (i18n !== 'es' && onlySpanish) {
      onChangeLocalization('es');
    }
  }, [i18n, onChangeLocalization, onlySpanish]);
  const { menuMasterLoading } = useGetMenuMaster();
  const downXL = useMediaQuery((theme: Theme) => theme.breakpoints.down('xl'));

  const { container, miniDrawer } = useConfig();

  useEffect(() => {
    if (!miniDrawer) {
      handlerDrawerOpen(!downXL);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downXL]);

  if (menuMasterLoading) return <Loader />;

  return (
    <RoleGuard allowedRoles={[USER_ROLES.MANAGER]}>
      <RestaurantProvider>
        <Box sx={{ display: 'flex', width: '100%' }}>
          {/* <Header /> */}
          <Drawer />

          <Box component="main" sx={{ width: 'calc(100% - 260px)', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
            {/* <Toolbar sx={{ mt: isHorizontal ? 8 : 'inherit' }} /> */}
            <Container
              maxWidth={container ? 'xl' : false}
              sx={{
                ...(container && { pl: { xs: 0, sm: 2.5 }, pr: { xs: 0, sm: 0 }, pt: 2 }),
                position: 'relative',
                minHeight: 'calc(100vh - 110px)',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <Outlet />
            </Container>
          </Box>
        </Box>
      </RestaurantProvider>
    </RoleGuard>
  );
}
